import { render, staticRenderFns } from "./lvshi.vue?vue&type=template&id=24c95e3e&scoped=true"
import script from "./lvshi.vue?vue&type=script&lang=js"
export * from "./lvshi.vue?vue&type=script&lang=js"
import style0 from "./lvshi.vue?vue&type=style&index=0&id=24c95e3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c95e3e",
  null
  
)

export default component.exports